import { render, staticRenderFns } from "./WorkflowDetails.vue?vue&type=template&id=b498c2c6&scoped=true"
import script from "./WorkflowDetails.vue?vue&type=script&lang=ts"
export * from "./WorkflowDetails.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowDetails.vue?vue&type=style&index=0&id=b498c2c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b498c2c6",
  null
  
)

export default component.exports